import React, { FunctionComponent, Fragment, MouseEvent, useState } from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from "@material-ui/core";
import { ConfirmDialog } from "components/UI";

export interface Props {
  icon: IconProp;
  onConfirmedClick: () => void;
  text: string;
  color?: string;
  confirmQuestion: JSX.Element;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
}


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    item: {
      display: "flex",
      cursor: "pointer",
      alignItems: "center",
      [theme.breakpoints.down("lg")]: {
        paddingTop: "6px",
        paddingBottom: "6px",
      },
      [theme.breakpoints.up("xl")]: {
        paddingTop: "8px",
        paddingBottom: "8px",
      },
    },
    icon: {
      [theme.breakpoints.down("lg")]: {
        marginRight: "7px",
      },
      [theme.breakpoints.up("xl")]: {
        marginRight: "10px",
      },
    },
    title: {
      [theme.breakpoints.down("lg")]: {
        fontSize: "12px",
      },
      [theme.breakpoints.up("xl")]: {
        fontSize: "16px",
      },
    },
  })
);

export const ToolbarItemWithConfirmation: FunctionComponent<Props> = (props) => {
  const classes = useStyles();
  
  const [showDialog, setShowDialog] = useState(false);
  
  const clickHandler = (event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    setShowDialog(true);
  }

  const cancelHandler = () => {
    setShowDialog(false);
  }

  const confirmHandler = () => {
    setShowDialog(false);
    props.onConfirmedClick();
  }

  return (
    <Fragment>
      <Box className={classes.item} onClick={clickHandler}>
        <FontAwesomeIcon color={props.color} icon={props.icon} className={classes.icon} />
        <Typography style={{color: props.color||""}} className={classes.title}>{props.text}</Typography>
      </Box>
      <ConfirmDialog
        open={showDialog}
        question={props.confirmQuestion}
        confirmButtonLabel={props.confirmButtonLabel || "Confirm"}
        cancelButtonLabel={props.cancelButtonLabel || "Cancel"}
        onCancel={cancelHandler}
        onConfirm={confirmHandler}
      />
    </Fragment>
  );
};

export default ToolbarItemWithConfirmation;